// Layer 4 (UI) — the KPI strip shared by every maintenance tab (a20-maintenance
// S7). Before this file each of the seven strips carried the same
// `grid grid-cols-2 gap-3 md:grid-cols-4` wrapper inline; the class string is
// the strip's whole definition, so it lives here once and the tabs compose it.
//
// Presentational only: the strip renders the four `KpiCard`s a tab hands it and
// derives nothing. The cards keep their own props — the strip passes no figure
// through and no transform moves.

import type { ReactNode } from 'react';

export function KpiStrip({ children }: { children: ReactNode }) {
  return <section className="grid grid-cols-2 gap-3 md:grid-cols-4">{children}</section>;
}
